<template>
  <div class="ListagemLancamentos">
    <div class="mx-3 my-2">
      <div class="row ListagemLancamentos_header py-2">
        <div v-for="(header, index) in tableHeaders"
             :key="index"
             :class="`col-${header.cols}`">
          <div @click="header.key === 'data_lancamento' && sortByDate()">
            {{ header.label }}
            <span v-if="header.key === 'data_lancamento'">
              {{ sortOrder === 1 ? '↑' : '↓' }}
            </span>
          </div>
        </div>
      </div>
    </div>

    <div v-for="(lancamento, index) in sortedLancamentos"
         :key="index"
         :class="`ListagemLancamentos_item ${lancamento.tipo === 'RECEITA' ? 'ListagemLancamentos_item__border_receita' : 'ListagemLancamentos_item__border_despesa'}`">
      <div class="row align-items-center p-2">
        <div class="col-1">
          {{ lancamento.data_lancamento | date }}
        </div>
        <div class="col-4"
             @click="showDetalhes(lancamento)">
          <div class="d-flex flex-column pl-4">
            <span class="pb-2">{{ lancamento.categoria.nome }}</span>
            <span class="pb-2">{{ lancamento.detalhamento }}</span>
            <span :style="{ fontSize: '14px' }"
                  class=" font-weight-bold">{{ getOrdemServicoNumero(lancamento) }}</span>
            <span v-if="lancamento.fornecedor && lancamento.fornecedor.nome"
                  class="pb-2 beneficiario">{{ lancamento.fornecedor.nome }}</span>
          </div>
        </div>
        <div class="col-1">
          {{ lancamento.atos }}
        </div>
        <div class="col-2 ListagemLancamentos_item__value_despesa">
          {{ handleDespesa(lancamento) }}
        </div>
        <div class="col-2 ListagemLancamentos_item__value_receita">
          {{ handleReceita(lancamento) }}
        </div>
        <div class="col-2">
          {{ lancamento.saldo | moneyToString }}
        </div>
      </div>
    </div>

    <div class="ListagemLancamentos_footer">
      <div class="row px-2 align-items-center">
        <div class="col-5">
          <b>Total</b>
        </div>
        <div class="col-7 row">
          <div class="col-2">
            <div class="row mb-2">
              <div class="col-12">
                <b>Atos</b>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                {{ getQtd() }}
              </div>
            </div>
          </div>
          <div class="col-3 pr-4 mr-2">
            <div class="row mb-2">
              <div class="col-12">
                <b>Despesas</b>
              </div>
            </div>
            <div class="row">
              <div class="col-12 nowrap">
                {{ getDespesas() | moneyToString }}
              </div>
            </div>
          </div>
          <div class="col-3 pl-4">
            <div class="row mb-2">
              <div class="col-12">
                <b>Receitas</b>
              </div>
            </div>
            <div class="row mb-2">
              <div class="col-12 nowrap">
                {{ getReceitas() | moneyToString }}
              </div>
            </div>
          </div>
          <div class="col-1 ml-5">
            <div class="row mb-2">
              <div class="col-12">
                <b>Saldo</b>
              </div>
            </div>
            <div class="row">
              <div class="col-12 nowrap">
                {{ getSaldo() | moneyToString }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { numberToMoney } from '../../utils/conversors'

  export default {
    name: 'ListagemLancamentos',
    components: {},
    props: {
      propLancamentos: { type: Array, default: () => [] },
      propTotais: { type: Object, default: null }
    },
    data () {
      return {
        abertos: [],
        sortKey: 'data_lancamento',  
        sortOrder: 1, 
        tableHeaders: [
          { label: 'Data', cols: '1 pl-4', key: 'data_lancamento' },
          { label: 'Tipo de serviço', cols: '4 pl-5' },
          { label: 'Qtd', cols: 1 },
          { label: 'Despesas', cols: 2 },
          { label: 'Receitas', cols: 2 },
          { label: 'Saldo', cols: 2 }
        ]
      }
    },
    computed: {
      sortedLancamentos () {
        const sortedByDate = [...this.propLancamentos].sort((a, b) => {
          const dateA = new Date(a[this.sortKey])
          const dateB = new Date(b[this.sortKey])
          if (this.sortOrder === 1) {
            return dateA - dateB // Crescente
          } else {
            return dateB - dateA // Decrescente
          }
        })

        const grouped = sortedByDate.reduce((groups, lancamento) => {
          const dateKey = lancamento.data_lancamento 
          const categoryKey = lancamento.categoria.nome

          if (!groups[dateKey]) {
            groups[dateKey] = []
          }

          let categoryGroup = groups[dateKey].find(group => group.category === categoryKey)
      
          if (!categoryGroup) {
            categoryGroup = { category: categoryKey, lancamentos: [] }
            groups[dateKey].push(categoryGroup)
          }
      
          categoryGroup.lancamentos.push(lancamento)

          return groups
        }, {})

        return Object.keys(grouped).map(dateKey => {
          return grouped[dateKey].reduce((result, group) => {
            return result.concat(group.lancamentos)
          }, [])
        }).flat()
      }
    },

    methods: {
      sortByDate () {
        this.sortOrder = this.sortOrder === 1 ? -1 : 1
      },
      openCloseDetalhes (index) {
        const indice = this.abertos.findIndex(aberto => aberto === index)

        if (indice != -1) {
          this.abertos.splice(indice, 1)
        } else {
          this.abertos.push(index)
        }
      },
      showDetalhes (lancamento) {
        this.$emit('showDetalhes', lancamento)
      },
      getQtd () {
        if (!!this.propTotais && this.propTotais.total_quantidade) {
          return this.propTotais.total_quantidade
        }
        return this.propLancamentos.map((lancamento) => lancamento.atos).reduce((a,b) => a + b, 0)
      },
      getDespesas () {
        if (!!this.propTotais && this.propTotais.total_despesa) {
          return this.propTotais.total_despesa
        } else {
          const despesas = this.propLancamentos.filter((lancamento) => lancamento.tipo === 'DESPESA')
          return despesas.map((despesa) => despesa.valor).reduce((a,b) => a + b, 0)
        } 
      },
      getReceitas () {
        if (!!this.propTotais && this.propTotais.total_receita) {
          return this.propTotais.total_receita
        } else {
          const receitas = this.propLancamentos.filter((lancamento) => lancamento.tipo === 'RECEITA')
          return receitas.map((receita) => receita.valor).reduce((a,b) => a + b, 0)
        }
      },
      getSaldo () {
        if (!this.propLancamentos || !this.propLancamentos.length) return

        if (!!this.propTotais && this.propTotais.total_saldo) {
          return this.propTotais.total_saldo
        }

        const receita = this.getReceitas()
        const despesa = this.getDespesas()

        return (receita - despesa)
      },
      goOS (lancamento) {
        const { registro, ordem_servico_id } = lancamento.ordemServicoItem.ordemServico

        if (!registro && ordem_servico_id) {
          this.$router.push({ name: 'ordem_servico_editar', params: { id: ordem_servico_id } })

          return
        }

        switch (registro.tipo_registro) {
        case 'O':
          this.$router.push({ name: 'resumo_obito', params: { id: registro.obito.obito_id, propIdOs: ordem_servico_id } })
          break
        case 'N':
          this.$router.push({ name: 'resumo_nascimento', params: { id: registro.nascimento.nascimento_id, propIdOs: ordem_servico_id  } })
          break
        case 'C':
        case 'CR':
          this.$router.push({ name: 'resumo_casamento', params: { id: registro.casamento.casamento_id, propIdOs: ordem_servico_id  } })
          break
        case 'D':
          this.$router.push({ name: 'resumo_habilitacao_casamento', params: { id: registro.habilitacaoCasamento.habilitacao_casamento_id, propIdOs: ordem_servico_id  } })
          break
        }
      },
      async deleteLancamento (lancamento) {
        const res = await displayMessage('question', 'Tem certeza que deseja excluir esse lançamento?')

        if (res.value) {
          this.$emit('deleteLancamento', lancamento)
        }
      },
      handleReceita (lancamento) {
        const {tipo, valor} = lancamento
        if (tipo === 'RECEITA') return numberToMoney(valor)
        else return 'R$ -'
      },
      handleDespesa (lancamento) {
        const {tipo, valor} = lancamento
        if (tipo === 'DESPESA') return numberToMoney(valor)
        else return 'R$ -'
      },
      getOrdemServicoNumero (lancamento) {
        if (lancamento && lancamento.ordemServicoItem && lancamento.ordemServicoItem.ordemServico) {
          return `Referente a ordem de serviço ${lancamento.ordemServicoItem.ordemServico.numero}`
        }
      }
    }
  }
</script>

<style lang="scss">
  .ListagemLancamentos {
    &_header {
      background: #01bfa5;
      color: #000;
      font-size: 16px;
      font-weight: bold;
      border-radius: 3px 0px;
    }

    &_item {
      margin-bottom: 6px;
      border: 1px solid #696969;
      border-radius: 3px;
      box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
      cursor: pointer;
      &:hover {
        background-color: #EAEAEA;
      }
      &__border_receita {
        border-left: 14px solid #205E3A;
      }
      &__border_despesa {
        border-left: 14px solid #8B0000;
      }
      &__value_receita {
        color: #205E3A;
      }
      &__value_despesa {
        color: #8B0000
      }
      &_header {
        background: #01bfa5;
        color: #000;
        font-size: 16px;
        font-weight: bold;
        border-radius: 3px 0px;
      }    

      &_footer {
        background: #eaeaea;
        border-radius: 0px 3px;
      }
    }


    &_footer {
      background: #fff;
      border: 1px solid #696969;
      border-radius: 3px;
      padding: 10px 0px;
      // position: sticky;
      // bottom: 10px;
      z-index: 2;
    }

    &_arrowDown {
      width: 15px;
      height: 15px;
      transition: 0.4s;
    }

    &_arrowUp {
      transition: 0.4s;
      transform: rotate(-180deg);
    }

    &_icon-sofia {
      width: 50px;
      height: 20px;
    }
  }

  .btn-lancamento {
    background: #fff;
  }

  .icon-trash {
    cursor: pointer;
    width: 30px;
    height: 30px;
    fill: rgb(100, 0, 0);
  }

  .icon-pending {
    cursor: pointer;
    width: 35px;
    height: 35px;
  }

  .nowrap {
    white-space: nowrap;
  }

  .beneficiario{
    text-decoration: underline;
  }
</style>